<template>
  <div class="mask" id="mask" @click="closeDialog">
    <div class="dialog">
      <div class="close-div"  @click="closeImg">
        <img class="closediglogimg" :src=" require('../../../../assets/appraise/close.png')" />
      </div>
     
      <div class="head">
        <div class="title" :class="{'line124': content==''}">{{title}}</div>
        <div v-if="content&&content.length>0" class="content">{{content}}</div>
      </div>
      <div class="btns">
        <div class="cancel" @click="cancel">{{cancelTxt}}</div>
        <div class="confirm" @click="confirm">{{confirmTxt}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // props: ['title', 'content', 'confirmTxt', 'cancelTxt'],
  props:{
    title: {
      type: String,
      default:()=>{
        return '确认审核？'
      }
    },
    content: {
      type: String,
      default:()=>{
        return '若该州市上报的材料缺失可将上报内容全部退回。'
      }
    },
    confirmTxt:{
      type: String,
      default:()=>{
        return '审核'
      }
    },
    cancelTxt:{
      type: String,
      default: ()=>{
        return '退回'
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    confirm() {
      this.$emit('confirm');
    },
    cancel() {
      this.$emit('checkback');
    },
    closeImg(){
      this.$emit('cancel');
    },
    // 点击蒙版关闭弹窗
    closeDialog(e) {
      let _con = document.querySelector('.dialog')
        if(_con) {
          if(!_con.contains(e.target)) {
            this.$emit('cancel');
          }
        }
    }
  }
};
</script>

<style scoped lang="less">
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
  .dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 260px;
    height: 172px;
    background-color: #fff;
    border-radius: 4px;
    .close-div{
      position: absolute;
      top: 4px;
      right: 4px;
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      .closediglogimg{
        width: 14px;
        height: 14px;
        
      }
    }
    
    .head {
      padding: 28px 32px 18px;
      height: 124px;
    }
    .title {
      margin-bottom: 12px;
      font-size: 18px;
      color: #333;
      font-weight: bold;
      text-align: center;
    }
    .line124 {
      line-height: 78px;
    }
    .content {
      font-size: 14px;
      line-height: 26px;
      color: #666;
      text-align: center;
    }
    .btns {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 48px;
      border-top: 1px solid #e5e5e5;
      &>div {
        width: 50%;
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        color: #36B374;
        text-align: center;
      }
      .cancel {
        border-right: 1px solid #e5e5e5;
      }
    }
  }
}
</style>